<template>
    <nav
        class="navbar has-shadow is-fixed-top"
        role="navigation"
        aria-label="main navigation"
    >
        <div class="navbar-brand">
            <router-link
                v-if="!hideLogin"
                :to="{
                    path: '/communities',
                }"
                class="navbar-item is-family-secondary has-text-primary title is-4 is-marginless"
                exact
            >
                <span
                    class="is-family-primary is-size-6 pr-1 is-hidden-mobile"
                    >{{ $t('App.navbar_back_to') }}</span
                >
                <span class="icon is-medium is-hidden-tablet pr-1">
                    <i class="mdi mdi-24px mdi-chevron-left"></i
                ></span>
                <span class="is-hidden-mobile">Labylok</span>
            </router-link>
            <div class="container">
                <div
                    class="is-hidden-tablet is-hidden-desktop navbar-item py-0"
                >
                    <div :class="isLoggedIn ? 'lb-centered' : 'container'">
                        <a class="navbar-item is-size-4 is-family-secondary">
                            {{ community.title }}
                        </a>
                        <!--communityNavbarActions
              :hide-login="hideLogin"
              class="navbar-item is-pulled-right"
              @information="$emit('information')"
              @share="$emit('share')"
            /-->
                    </div>
                    <div
                        v-if="
                            !isLoggedIn && windowSize == 'mobile' && !hideLogin
                        "
                        class="container"
                    >
                        <app-navbar-user-menu class="is-pulled-right" />
                    </div>
                </div>
            </div>
            <a
                v-if="!hideLogin && (isLoggedIn || windowSize !== 'mobile')"
                role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbar"
                @click="menuActive = !menuActive"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div
            :class="{ 'is-active': menuActive }"
            class="navbar-menu"
            @click="menuActive = false"
        >
            <div class="navbar-start"></div>
            <a
                class="navbar-item is-size-4 is-family-secondary is-hidden-mobile"
            >
                {{ community.title }}
            </a>
            <!--CommunityNavbarActions 
        :hide-login="hideLogin"
        class="is-hidden-mobile"
        @information="$emit('information')"
        @share="$emit('share')"
      /-->
            <div class="navbar-end">
                <app-navbar-user-menu
                    v-if="!hideLogin && (isLoggedIn || windowSize !== 'mobile')"
                />
            </div>
        </div>
    </nav>
</template>

<script>
import AppNavbarUserMenu from '@/components/AppNavbarUserMenu';
import CommunityNavbarActions from '@/components/CommunityNavbarActions';
export default {
    components: {
        AppNavbarUserMenu,
        CommunityNavbarActions,
    },
    props: {
        hideLogin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuActive: false,
        };
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        windowSize() {
            return this.$mq;
        },
    },
    mounted() {},
};
</script>

<style></style>
